<template>
  <v-row
    align="center"
    justify="center"
    class="ma-0"
  >
    <v-col
      cols="12"
      sm="8"
      md="4"
      lg="4"
      xl="3"
    >
      <v-row
        align="center"
        justify="center"
      >
        <v-col class="my-4">
          <v-img
            contain
            src="/img/header_logo.png"
            height="40px"
            alt="NetWorkT Team & Telekom Logo"
          />
        </v-col>
      </v-row>
      <v-card outlined>
        <Forgot />
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import Layout from '@/Layouts/Basic'
import Forgot from '@/Components/Auth/Forgot'

export default {
   metaInfo: { title: 'Forgot Password' },
   components: {
      Forgot
   },
   layout: (h, page) => h(Layout, [page]),
   data () {
      return {
         //
      }
   },
   methods: {
      //
   },
}
</script>
